import { FunctionComponent } from "react";
import "./styles/Timeline.css";
import TimelineItem from "./TimelineItem";

interface TimelineWrapperProps {
  items: Array<any>;
  alternative?: boolean;
}

const TimelineWrapper: FunctionComponent<TimelineWrapperProps> = ({
  items,
  alternative,
}) => {
  return (
    <div className="timeline-wrapper">
      {/* <div className="timeline-divider" /> */}
      {items.map((item, index) => (
        <TimelineItem
          key={index}
          {...item}
          positionNumber={index}
          position={alternative && index % 2 === 0 ? "left" : "right"}
          last={index === items.length - 1}
        />
      ))}
    </div>
  );
};

export default TimelineWrapper;
